import { createAlertsManager } from '@bigcommerce/big-design';

// Standalone so non-component modules (e.g. redux thunks) can surface alerts
// without importing App.js and creating a circular dependency.
export const alertsManager = createAlertsManager();
